<template>
  <div class="workdetail" :class="systemInfo.isPhoneX ? 'iphoneX' : ''">
    <div class="goback" @click="goBack" v-if="!this.systemInfo.isNfPlus"></div>
    <!-- 顶部广告图位置 -->
    <div
      class="advertisementtop"
      ref="workDetailAdv_top"
      v-if="this.adDetail && this.adDetail.detailPageTop && this.adDetail.detailPageTop.picUrl"
      @click="handleClickAdv(adDetail.detailPageTop.appJump, 1)"
    >
      <img v-lazy="this.adDetail.detailPageTop.picUrl" alt="" />
      <span class="advertisementtxt" v-if="this.adDetail.detailPageTop.label">{{ this.adDetail.detailPageTop.label }}</span>
    </div>
    <!-- 没有图片的时候显示默认图片
    <div class="defaultimg" v-if="this.worksDetail.mediaFiles.length == 0">
      <img v-lazy="this.worksDetail.worksDefaultPic" alt="" style="max-width:100%; max-height:100%" />
    </div> -->
    <!-- 有图片的时候显示轮播图 -->
    <div class="swiper-container">
      <!-- <div class="swiper-container" v-if="false"> -->
      <div class="swiper-wrapper" v-if="this.worksDetail.mediaFiles.length > 0">
        <div
          class="swiper-slide"
          v-for="(item, index) in this.worksDetail.mediaFiles"
          :key="index"
          @click="imgPreview(item, index)"
          :class="item.fileType"
        >
          <NfVideo v-if="item.fileType === 'video'" :videoUrl="item.url" :poster="item.cover" :ref="`worksDetail_file_item_${index}`">
            <div class="swiper-pagination swiper-pagination-fraction video-pagination" slot="pagination"></div>
          </NfVideo>
          <div class="work-img-wrapper" v-else>
            <img v-lazy="_resolveImgToSmall(item.url)" class="work-img" alt="" style="max-width:100%; max-height:100%" />
          </div>
        </div>
      </div>
      <div class="gauss-wrapper" v-if="guassPoster">
        <img :src="_resolveImgToSmall(guassPoster)" class="gauss" />
      </div>
      <div class="swiper-wrapper a0" v-if="worksDetail.id && this.worksDetail.mediaFiles && this.worksDetail.mediaFiles.length === 0">
        <div class="swiper-slide" @click="imgPreview(1, 0)">
          <div class="work-img-wrapper">
            <img v-lazy="this.worksDetail.worksDefaultPic" class="work-img" alt="" style="max-width:100%; max-height:100%" />
            <div class="gauss-wrapper">
              <img :src="this.worksDetail.worksDefaultPic" class="gauss" v-if="this.worksDetail.worksDefaultPic" />
            </div>
          </div>
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination swiper-pagination-fraction" v-show="currentFileType !== 'video'"></div>
    </div>
    <div class="infocontent" :class="{ contiphonex: this.systemInfo.isPhoneX }">
      <h1>
        <span
          class="workstype"
          v-if="this.worksDetail.worksType && JSON.stringify(this.worksDetail.worksType) !== '{}'"
          :style="{ background: this.worksDetail.worksType.color }"
        >
          {{ this.worksDetail.worksType.typeName }}
        </span>
        {{ this.worksDetail.title }}
      </h1>
      <h2 style="font-weight: normal;">
        <span>{{ authorInfo }}</span>
      </h2>
      <!-- <p class="tips jump" @click="handleJumpWorksList">更多项目</p> -->
      <p class="contword" v-html="this.worksDetail.detail" style="margin-top:12px;">
        <!-- <pre > -->
        {{ this.worksDetail.detail }}
        <!-- </pre> -->
      </p>
    </div>
    <!-- 底部广告图位置 -->
    <div
      class="advertisementbottom"
      ref="workDetailAdv_bottom"
      v-if="this.adDetail && this.adDetail.detailPageBottom && this.adDetail.detailPageBottom.picUrl"
      @click="handleClickAdv(adDetail.detailPageBottom.appJump, 2)"
    >
      <img v-lazy="this.adDetail.detailPageBottom.picUrl" alt="" />
      <span class="advertisementtxt" v-if="this.adDetail.detailPageBottom.label">{{ this.adDetail.detailPageBottom.label }}</span>
    </div>
    <div class="bottom" v-if="isI" :class="{ iphonex: this.systemInfo.isPhoneX }">
      <BottomCtrl
        :worksId="worksDetail.id"
        :hasPraised="worksDetail.like"
        :praiseNum="worksDetail.likeNum"
        :isNfPlus="systemInfo.isNfPlus"
        @resfresPraise="handlePraise"
        @refreshLogin="handleRefreshWorkList"
        @jumpWorksList="handleJumpWorksList"
        @shareWorkDetail="handleShareWorkDetail"
        @backPraise="handleBackPraise"
        @jumpContribute="handleJumpContribute"
      />
    </div>
    <!-- 选择作品类型信息 -->
    <chosetypes :show="showItemseason" :worksTypes="this.worksTypeList" @input="submitType"></chosetypes>
  </div>
</template>

<script>
import getParamsFromUrl from "@/utils/getParamsFromUrl"
import getUserInfo from "@/mixins/getUserInfo"
import advHandlers from "@/mixins/advHandlers"
import Swiper from "swiper"
import liken from "../../assets/images/icon_like_n.png"
import likes from "../../assets/images/icon_like_s.png"
import { mapActions, mapGetters, mapMutations } from "vuex"
import setDocuemntTtitle from "@/utils/setDocumentTitle"
import initWxShare from "@/utils/initWxShare"
import chosetypes from "@/components/ChoseTypes/index"
import NfVideo from "@/components/NfVideo"
import BottomCtrl from "./components/BottomCtrl"
import resolveUserUnit from "@/utils/resolveUserUnit"
import { buryingPoint_detail, buryingPoint_shareWork, AdvExposure, buryingPoint_click_adv } from "@/server/buryingPoint"
import { resolveImgToSmall } from "@/utils/resolveImgToSmall"
import jumpPage from "@/mixins/jumpPage"

export default {
  name: "workDetail",
  components: {
    chosetypes,
    NfVideo,
    BottomCtrl
  },
  data() {
    return {
      showwx: false,
      thumber: false,
      isI: false,
      activeIndex: 0,
      coverImg: "",
      background: "#EF9F28",
      showItemseason: false,
      worksTypeList: [], //作品类型列表数据
      oldActiveIndex: 0
    }
  },
  created() {
    this.hasActivity()
    // this.getWorksDetail({ params: { id: workId.workId } })
    if (this.adDetail && JSON.stringify(this.adDetail) === "{}") {
      this.getAdDetail()
    }
    document.querySelector("#app").style.overflow = "auto"
    this._getActivityInfo()
  },
  mounted() {},
  mixins: [getUserInfo, advHandlers, jumpPage],
  methods: {
    ...mapMutations({
      reviseWorkItem: "workDetail/reviseWorkItem",
      toast: "toast/showToast",
      reviseHomeWorkListItem: "home/reviseWorkItem"
    }),
    ...mapActions({
      getWorksDetail: "workDetail/getWorksDetail",
      getWorksType: "workDetail/getWorksType",
      getAdDetailInfo: "workDetail/getAdDetailInfo",
      getActivityInfo: "activityInfo/getActivityInfo"
    }),
    imgPreview(item, index) {
      const videoLength = this.worksDetail.mediaFiles.filter(item => item.fileType === "video").length

      this.$router.push({ path: "/preview", query: { imgInfor: index - videoLength } })
    },
    shareInfo() {
      const origin = window.location.origin
      const pathname = window.location.pathname
      buryingPoint_shareWork()
      let worksTypeName =
        this.worksDetail.worksType && this.worksDetail.worksType.typeName ? this.worksDetail.worksType.typeName + " | " : ""
      window.nfplusJsbridge.share({
        title: worksTypeName + this.worksDetail.title,
        content: this.shareDesc,
        icon: this.coverImg,
        url: `${origin}${pathname}?route=workDetail&workId=${this.worksDetail.id}&id=${this.worksDetail.activityId}`
      })
    },
    thumbers() {
      this.thumber = true
      // getWorkDetail(params).then(res => {
      //   const workDetail = res
      //   // window.console.log(workList)
      //   commit("setworkDetail", workDetail)
      // })
    },
    showshare(noshow) {
      this.showwx = noshow
    },
    handlePraise() {
      this.reviseWorkItem({ like: true, likeNum: this.worksDetail.likeNum + 1 })
      if (this.workDetailIndex !== "") {
        this.reviseHomeWorkListItem({
          index: this.workDetailIndex,
          workItem: {
            ...this.worksDetail
          }
        })
      }
    },
    handleBackPraise() {
      this.reviseWorkItem({ like: false, likeNum: this.worksDetail.likeNum - 1 })
      if (this.workDetailIndex !== "") {
        this.reviseHomeWorkListItem({
          index: this.workDetailIndex,
          workItem: {
            ...this.worksDetail
          }
        })
      }
    },
    handleRefreshWorkList() {
      this.$emit("refreshWorkList")
    },
    async hasActivity() {
      const workId = this.$route.query.workId || getParamsFromUrl().workId
      await this.getWorksDetail({ params: { id: workId } })
      if (!this.worksDetail || !this.worksDetail.id) return
      const mediaFiles = (this.worksDetail.mediaFiles || []).filter(item => item.mediaFileType === "PICTURE")
      const videos = (this.worksDetail.videos || []).filter(item => item.mediaFileType === "VIDEO")
      const mediaCoverItem = mediaFiles.find(item => item.cover)
      const mediaCover = mediaCoverItem ? mediaCoverItem.url : ""
      const defaultMediaCover = mediaFiles[0] ? mediaFiles[0].url : ""
      const videoCover = videos[0] ? videos[0].coverImgUrl : ""
      const cover = mediaCover || videoCover || defaultMediaCover || this.worksDetail.worksDefaultPic
      this.coverImg = cover
      this.initShare()
      this.handleUnkown()
      if (this.worksDetail.activityName) {
        setDocuemntTtitle(this.worksDetail.activityName)
      }
      this.initSwiper()
      buryingPoint_detail({ activityId: this.worksDetail.activityId, optionId: this.worksDetail.id })
    },
    goBack() {
      const isFirstRoute = window.routerArr.length === 1
      if (isFirstRoute) {
        this.$router.replace({ path: "/" })
      } else {
        this.$router.go(-1)
      }
    },
    async submitType(submittype) {
      await this.getWorksType({ params: { typeId: submittype, worksId: this.worksDetail.id } })
      if (this.submitSuccess) {
        this.toast("提交成功!")
        document.querySelector("#app").style.overflow = "auto"
        this.showItemseason = false
        const workId = getParamsFromUrl()
        await this.getWorksDetail({ params: { id: workId.workId } })
      } else {
        this.toast("提交失败!请稍后再试")
      }
    },
    async getAdDetail() {
      let option = {
        params: {}
      }
      await this.getAdDetailInfo(option)
      this.$nextTick(() => {
        this.swiper && this.swiper.destroy()
        this.initSwiper()
      })
      this.initAdvBuryingPoint()
    },
    initShare() {
      const origin = window.location.origin
      const pathname = window.location.pathname
      let worksTypeName =
        this.worksDetail.worksType && this.worksDetail.worksType.typeName ? this.worksDetail.worksType.typeName + " | " : ""
      const shareInfo = {
        title: worksTypeName + this.worksDetail.title,
        desc: this.shareDesc,
        link: `${origin}${pathname}?route=workDetail&workId=${this.worksDetail.id}&id=${this.worksDetail.activityId}`,
        imgUrl: this.coverImg
      }
      const nfPlusShareInfo = {
        shareTitle: worksTypeName + this.worksDetail.title,
        shareIcon: this.coverImg,
        shareDesc: this.shareDesc,
        shareUrl: `${origin}${pathname}?route=workDetail&workId=${this.worksDetail.id}&id=${this.worksDetail.activityId}`
      }
      initWxShare(shareInfo)
      window.nfplusJsbridge.setShareInfo(nfPlusShareInfo)
    },
    slideChange(activeIndex) {
      const oldFileInfo = this.worksDetail.mediaFiles[this.oldActiveIndex]
      const oldFileIsVideo = oldFileInfo.fileType === "video"
      if (oldFileIsVideo) {
        const key = `worksDetail_file_item_${this.oldActiveIndex}`
        const videoDom = this.$refs[key][0]
        videoDom && videoDom.handlePause()
      }
      this.oldActiveIndex = activeIndex
      this.activeIndex = activeIndex
    },
    initSwiper() {
      this.$nextTick(() => {
        const _this = this
        this.oldActiveIndex = 0
        this.swiper = new Swiper(".swiper-container", {
          paginationType: "fraction",
          // observeParents: true, //修改swiper的父元素时，自动初始化swiper
          pagination: ".swiper-pagination",
          onSlideChangeEnd(swiper) {
            _this.slideChange(swiper.activeIndex)
          }
        })
      })
    },
    handleJumpWorksList() {
      this.$router.push({ path: "/workCollection", query: { userId: this.worksDetail.userId } })
    },
    handleShareWorkDetail() {
      this.shareInfo()
    },
    handleUnkown() {
      this.isI = this.worksDetail.reviewStatus === "PASS"
      this.worksTypeList = this.allWorksTypes.filter(item => {
        return item.display == "YES"
      })
      if (this.worksTypeList && this.worksTypeList.length > 0 && this.worksDetail.userUuid == this.userInfo.userUuid) {
        if (!this.worksDetail.worksType || JSON.stringify(this.worksDetail.worksType) == "{}") {
          if (this.worksDetail.reviewStatus !== "REJECT" && this.worksDetail.reviewStatus !== "REVOKE") {
            this.showItemseason = true
            document.querySelector("#app").style.overflow = "hidden"
          }
        }
      }
    },
    _resolveImgToSmall(imgUrl) {
      return resolveImgToSmall(imgUrl)
    },
    _getActivityInfo() {
      const activityId = getParamsFromUrl().id
      const hasActivityInfo = !!this.activityDetailDesc.id
      if (!activityId || hasActivityInfo) return
      const params = {
        params: {
          id: activityId
        },
        showToast: false,
        showLoading: false,
        notInitShare: true
      }
      this.getActivityInfo(params)
    },
    initAdvBuryingPoint() {
      this.$nextTick(() => {
        const adv_top = this.$refs.workDetailAdv_top
        const adv_bottom = this.$refs.workDetailAdv_bottom
        if (adv_top) {
          const buryingPoint_adv_top_option = {
            action: 23,
            clickPosition: 1,
            optionId: this.worksDetail.id
          }
          this.adv_top_intersectionObserver = new AdvExposure(adv_top, buryingPoint_adv_top_option)
          this.adv_top_intersectionObserver.observe()
        }
        if (adv_bottom) {
          const buryingPoint_adv_bottom_option = {
            action: 23,
            clickPosition: 2,
            optionId: this.worksDetail.id
          }
          this.adv_bottom_intersectionObserver = new AdvExposure(adv_bottom, buryingPoint_adv_bottom_option)
          this.adv_bottom_intersectionObserver.observe()
        }
      })
    },
    unobserveAdvIntersectionObserver() {
      this.adv_top_intersectionObserver && this.adv_top_intersectionObserver.unobserve()
      this.adv_bottom_intersectionObserver && this.adv_bottom_intersectionObserver.unobserve()
    },
    destroy() {
      this.unobserveAdvIntersectionObserver()
    },
    handleClickAdv(jumpUrl, clickPosition) {
      buryingPoint_click_adv({
        clickPosition,
        optionId: this.worksDetail.id
      })
      this.handleJumpAdvDetail(jumpUrl)
    },
    handleJumpContribute() {
      this.handleJumpPage("contribute")
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "userInfo/userInfo",
      worksDetail: "workDetail/worksDetail",
      systemInfo: "systemInfo",
      activityDetail: "activityInfo/activityDetail",
      activityDetailDesc: "activityInfo/activityDetailDesc",
      firstDetail: "workDetail/firstDetail",
      submitSuccess: "workDetail/submitSuccess",
      adDetail: "workDetail/adDetail",
      allWorksTypes: "activityInfo/allWorksTypes",
      workDetailIndex: "workDetail/workDetailIndex",
      hidePraise: "activityInfo/hidePraise"
    }),
    singleShareDesc() {
      return this.activityDetailDesc.singleShareDesc || this.worksDetail.singleShareDesc
    },
    authorInfo() {
      const singleShareDesc = this.singleShareDesc || ""
      // const singleShareDesc = ""
      let authorInfoArr = [
        // this.worksDetail.userName || "",
        `${this.userUnit}${this.worksDetail.grade ? this.worksDetail.grade.gradeName || "" : ""}`
      ]
      authorInfoArr = authorInfoArr.filter(authorItem => authorItem !== "")
      let authorInfoStr = authorInfoArr.join(" ")
      if (singleShareDesc !== "" && authorInfoArr.length > 1) {
        authorInfoStr = `（${authorInfoStr}）`
      }
      const authorInfoDescArr = [singleShareDesc, authorInfoStr].filter(item => item !== "")
      return authorInfoDescArr.join(" ")
    },
    shareDesc() {
      // const shareDescArr = [this.authorInfo, this.firstDetail].filter(item => item !== "")
      // return shareDescArr.join(" ")
      return `${this.userUnit} ${this.firstDetail}`
    },
    powericon() {
      return this.thumber ? likes : liken
    },
    guassPoster() {
      const bannerItem = this.worksDetail.mediaFiles[this.activeIndex]
      if (!bannerItem) return ""
      const fileType = bannerItem.fileType
      const isVideo = fileType === "video"
      return isVideo ? bannerItem.cover : bannerItem.url
    },
    currentFileType() {
      const bannerItem = this.worksDetail.mediaFiles[this.activeIndex]
      if (!bannerItem) return ""
      return bannerItem.fileType
    },
    userUnit() {
      return resolveUserUnit(this.worksDetail.defaultOpt)
    }
  },
  beforeDestroy() {
    this.destroy()
  }
}
</script>
<style lang="scss">
.workdetail {
  .swiper-container-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    bottom: 0px;
    left: 89%;
  }
}
</style>
<style lang="scss" scoped>
@import "../../../node_modules/swiper/dist/css/swiper.min.css";
.workdetail {
  width: 100%;
  padding-bottom: 1.5rem;
  background: #ffffff;
  &.iphoneX {
    padding-bottom: calc(1.5rem + 34px);
  }
  .goback {
    width: 0.88rem;
    height: 0.88rem;
    background: url("../../assets/images/nav_icon_back_white@1x.png") no-repeat center center;
    background-size: 0.3rem 0.48rem;
    position: absolute;
    top: 0.1rem;
    left: 0rem;
    z-index: 10;
  }
  .advertisementtop {
    position: relative;
    width: 100%;
    height: 1.48rem;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin-bottom: 0.1rem;
    img {
      width: 100%;
      display: block;
    }
    .advertisementtxt {
      position: absolute;
      bottom: 0.1rem;
      right: 0.2rem;
      font-family: PingFangSC-Regular;
      font-size: 0.2rem;
      color: #ffffff;
      letter-spacing: 0;
      padding: 0.03rem 0.12rem 0.05rem 0.12rem;
      background: rgba(127, 127, 127, 0.8);
      border-radius: 0.04rem;
    }
  }
  .defaultimg {
    width: 100%;
    height: 4.22rem;
    border-radius: 0px 0px 0px 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #eeeeee;
    overflow: hidden;
  }
  .swiper-container {
    width: 100%;
    height: 4.22rem;
    background: #eeeeee;
    .gauss-wrapper {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      z-index: 1;
      .gauss {
        width: 150%;
        height: 150%;
        object-fit: cover;
        filter: blur(0.7rem);
      }
    }
    .swiper-wrapper {
      position: relative;
      z-index: 2;
    }
    .swiper-slide {
      display: flex;
      justify-content: center;
      align-items: center;
      background: transparent;
      overflow: hidden;
      position: relative;
      z-index: 2;
      &.video {
        border-radius: 0;
      }
      .work-img-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        .work-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          position: relative;
          z-index: 2;
        }
      }
    }
    // img {

    // }
    .swiper-pagination {
      width: 0.88rem;
      font-family: PingFangSC-Regular;
      font-size: 0.24rem;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 0.36rem;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 0.2rem 0 0 0;
      right: 0 !important;
      height: 0.36rem;
      bottom: 0;
      &.video-pagination {
        position: relative;
        left: 0;
        bottom: 0;
      }
    }
  }
  .infocontent {
    padding: 0.45rem;
    h1 {
      font-family: PingFang-SC-Bold;
      font-size: 0.36rem;
      color: #333333;
      letter-spacing: 0;
      line-height: 0.5rem;
      .workstype {
        font-family: PingFangSC-Regular;
        font-size: 0.22rem;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 0.4rem;
        padding: 0.02rem 0.1rem;
        border-radius: 0.2rem;
        display: inline-block;
        margin-right: 0.1rem;
        position: relative;
        top: -0.03rem;
      }
    }
    h2 {
      font-family: PingFangSC-Regular;
      font-size: 0.3rem;
      color: #999999;
      letter-spacing: 0;
      width: 100%;
      line-height: 0.42rem;
      margin-top: 0.1rem;
      word-break: break-all;
      white-space: pre-wrap;
    }
    .tips {
      &.jump {
        font-family: PingFangSC-Regular;
        font-size: 0.3rem;
        color: #43a0ff;
        letter-spacing: 0;
        line-height: 0.42rem;
        cursor: pointer;
        margin: 0.1rem 0 0.2rem;
        position: relative;
        display: flex;
        align-items: center;
        &:active {
          opacity: 0.7;
        }
        &::after {
          content: "";
          display: block;
          width: 0.3rem;
          height: 0.3rem;
          background: url("../../assets/images/icon_arrow_blue.png") no-repeat center;
          background-size: 90%;
        }
      }
    }
    .contword {
      width: 100%;
      font-family: PingFangSC-Regular;
      font-size: 0.32rem;
      color: #333333;
      letter-spacing: 0;
      line-height: 0.46rem;
      word-wrap: break-word;
      // pre {
      //   width: 100%;
      //   font-family: PingFangSC-Regular;
      //   font-size: 0.32rem;
      //   color: #333333;
      //   letter-spacing: 0;
      //   line-height: 0.46rem;
      //   white-space: pre-wrap; /*css-3*/
      //   white-space: -moz-pre-wrap; /*Mozilla,since1999*/
      //   white-space: -pre-wrap; /*Opera4-6*/
      //   white-space: -o-pre-wrap; /*Opera7*/
      //   word-wrap: break-word; /*InternetExplorer5.5+*/
      // }
    }
  }
  .advertisementbottom {
    position: relative;
    width: 6.9rem;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin: 0 0.3rem 0.3rem 0.3rem;
    img {
      width: 100%;
      display: block;
    }
    .advertisementtxt {
      position: absolute;
      bottom: 0.1rem;
      right: 0.2rem;
      font-family: PingFangSC-Regular;
      font-size: 0.2rem;
      color: #ffffff;
      letter-spacing: 0;
      padding: 0.03rem 0.12rem 0.05rem 0.12rem;
      background: rgba(127, 127, 127, 0.8);
      border-radius: 0.04rem;
    }
  }
  .bottom {
    position: fixed;
    bottom: 0.4rem;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .iphonex {
    padding-bottom: calc(34px - 0.2rem);
  }
  .contiphonex {
    padding-bottom: 1rem;
  }
}
</style>
